import { FC } from 'react';

import { CustomHandle } from '../custom-handle';
import { ICustomNode } from '../custom-node';
import './basic-info-action.scss';

// The tier-0 "Basic Info" step is presence-only: placing it in the flow is the
// whole configuration. First/Last name are collected from the applicant; contact
// details (email/phone/country) are inherited from the earlier OTP verification
// step, so there is nothing to configure — this body just summarises what the
// step collects, consistent with how the step renders in the session viewer.
const BASIC_INFO_FIELDS = [
	{ key: 'firstName', label: 'First name' },
	{ key: 'lastName', label: 'Last name' },
];

export const BasicInfoAction: FC<ICustomNode> = ({ id: nodeId }) => {
	return (
		<div className="basic-info-action">
			<CustomHandle value={nodeId} />
			<div className="basic-info-action__summary">
				<div className="basic-info-action__caption">Applicant provides</div>
				{BASIC_INFO_FIELDS.map(field => (
					<div className="basic-info-action__field" key={field.key}>
						<span className="basic-info-action__field-label">
							{field.label}
						</span>
						<span className="basic-info-action__field-badge">Required</span>
					</div>
				))}
				<div className="basic-info-action__note">
					Contact (email &amp; phone) inherited from the earlier verification
					step.
				</div>
			</div>
		</div>
	);
};
